import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Navigation from "../Navigation";
import LandingPage from "../Landing";
import SignUpPage from "../SignUp";
import SignInPage from "../SignIn";
import PasswordForgetPage from "../PasswordForget";
import HomePage from "../Home";
import AccountPage from "../Account";
// import AdminPage from "../Admin";
import BookDetailsPage from "../GoogleBooks/bookDetails";
import ShelfTemplate from "../YourShelf";
import ToReadList from "../YourShelf/toReadList";
import BooksReadList from "../YourShelf/booksReadList";
import * as ROUTES from "../../constants/routes";
import "bulma/css/bulma.css";


import { withAuthentication } from "../Session";

const App = () => (
  <Router>
  
    <div>
      <Navigation />
      <hr />
      <Route exact path={ROUTES.LANDING} component={LandingPage} />
      <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
      <Route path={ROUTES.SIGN_IN} component={SignInPage} />
      <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
      <Route path={ROUTES.HOME} component={HomePage} />
      <Route path={ROUTES.ACCOUNT} component={AccountPage} />
      {/* <Route path={ROUTES.ADMIN} component={AdminPage} /> */}
      <Route
        path={`${ROUTES.BOOK_DETAILS}/:bookId`}
        component={BookDetailsPage}
      />
      <Route exact path={`${ROUTES.YOUR_SHELF}`} component={ShelfTemplate} />
      <Route exact path={`${ROUTES.TO_READ_LIST}`} component={ToReadList} />
      <Route exact path={`${ROUTES.BOOKS_READ}`} component={BooksReadList} />
    </div>
  </Router>
);

export default withAuthentication(App);
